import { render, staticRenderFns } from "./desktopInterstitial.vue?vue&type=template&id=554157c0&scoped=true&"
import script from "./desktopInterstitial.vue?vue&type=script&lang=js&"
export * from "./desktopInterstitial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554157c0",
  null
  
)

export default component.exports